import { Controller } from "@hotwired/stimulus"

// Plan recommender — on the pricing page, the operator types how many units they
// have and the matching plan card is highlighted ("✓ Recommended for your size").
// Pure client-side: each card carries data-unit-cap (empty string = the uncapped
// top plan). We pick the FIRST card whose cap >= the entered units, falling back
// to the uncapped plan, then the last card. All cards stay visible/selectable.
export default class extends Controller {
  static targets = ["units", "card", "badge"]

  static highlightClasses = ["ring-2", "ring-primary-500", "border-primary-500", "shadow-lg"]

  recommend() {
    this.clear()

    const units = parseInt(this.unitsTarget.value, 10)
    if (!Number.isFinite(units) || units <= 0) return

    const match = this.matchFor(units)
    if (!match) return

    match.classList.add(...this.constructor.highlightClasses)
    const badge = match.querySelector("[data-plan-recommender-target='badge']")
    if (badge) badge.classList.remove("hidden")
  }

  matchFor(units) {
    // First plan whose cap can hold the entered units.
    const capped = this.cardTargets.find((card) => {
      const cap = card.dataset.unitCap
      return cap !== "" && cap !== undefined && units <= parseInt(cap, 10)
    })
    if (capped) return capped

    // Otherwise the uncapped (unlimited) top plan, then the last card as a guard.
    const uncapped = this.cardTargets.find((card) => card.dataset.unitCap === "")
    return uncapped || this.cardTargets[this.cardTargets.length - 1]
  }

  clear() {
    this.cardTargets.forEach((card) => {
      card.classList.remove(...this.constructor.highlightClasses)
    })
    this.badgeTargets.forEach((badge) => badge.classList.add("hidden"))
  }
}
